export const StoryData = {
      title:"Our Story",
            desc:"We blend code and creativity to turn digital dreams into reality. Our mission is to craft seamless interactions and unforgettable experiences, putting users at the heart of everything we do.",
            colorDesc:"We bridge the gap between vision and execution, ensuring every solution is tailored to your unique journey."
      

}